<template>
  <paginated-table
    endpoint="user_reports"
    :label="$t('views.profile.reports.title')"
    :columns="columns"
    :fetch-params="{ user_id: $store.state.user.id }"
    :load-relations="['report']"
    initial-sort-by="report.created_at"
    :initial-sort-desc="true"
    :show-generate-csv="false"
    :show-action-column="false"
    sync-filters-with-url
  >
    <template #cell(path)="{ item }">
      <file-download-link
        v-if="item.path"
        :api-url="`user_reports/${item.id}/download`"
        :filename="formatReportFilename(item.report.report_key)"
        download
      />
      <div v-else>{{ $t("views.profile.reports.status.not_generated") }}</div>
    </template>
  </paginated-table>
</template>

<script>
import FileDownloadLink from "@/components/shared/FileDownloadLink.vue";
import { capitalize, slugify } from "@/helpers/filters";
import Authenticated from "@/mixins/Authenticated";

import PaginatedTable from "@/components/shared/PaginatedTable.vue";
import { Column } from "@/components/shared/PaginatedTableColumns";

export default {
  name: "ProfileReports",
  components: { FileDownloadLink, PaginatedTable },
  mixins: [Authenticated],
  data() {
    return {
      columns: [
        new Column("id", capitalize(this.$t("lists.id")), "id", {
          showByDefault: false,
        }),
        Column.withSelect("report.type", this.$t("views.profile.reports.columns.type"), [
          {
            value: null,
            label: this.$t("views.profile.reports.filters.all"),
          },
          {
            value: "yearly-owner-income",
            label: this.$t("views.profile.reports.filters.yearly_owner_income"),
            variant: "success",
          },
        ]),
        new Column("report.report_key", this.$t("views.profile.reports.columns.for")),
        Column.withoutFilter("path", this.$t("views.profile.reports.columns.file"), "text", {
          sortable: false,
        }),
      ],
    };
  },
  methods: {
    formatReportFilename(year) {
      return this.$t("views.profile.reports.filename.yearly_income", {
        year,
        name: slugify(this.$store.state.user.full_name),
      });
    },
  },
};
</script>

<style lang="scss"></style>
